import MDButton from "components/MDButton";
import { hojeMaisDias } from "utils/dataCalendario";
import DataTable from "examples/Tables/DataTable";
import { useState } from "react";
import AdicionarConta from "./addConta";
import EditarDadoReceber from "layouts/receivables/components/editData";
import EditarDadoPagar from "layouts/payables/components/editData";
import { useEffect } from "react";
import { Alert, Icon, Tooltip } from "@mui/material";
import { commaToDot } from "utils/numberComma";
import {
  DIAS_PRAZO_PAGAMENTO,
  PARCELAS_PRAZO_PAGAMENTO,
  PRAZO_PAGAMENTO,
} from "./yupSchema";

export default function Contas({
  formik,
  refAddItem,
  isDetalhar = false,
  isReceber = false,
  cliente = null,
  valorTotal = null,
  refreshParent = () => {},
  // () => Promise<contas salvas do pedido>; quando informado, editar uma conta
  // salva recarrega só as contas, sem descartar o resto do formulário.
  buscarContasSalvas = null,
  dataPedido = null,
}) {
  const [showAddState, setShowAddState] = useState(false);
  const [showEditStateNew, setShowEditStateNew] = useState(false);
  const [currentEditNew, setCurrentEditNew] = useState(null);

  const [showEditStateCurr, setShowEditStateCurr] = useState(false);
  const [currentIdAction, setCurrentIdAction] = useState(null);
  const [rows, setRows] = useState([]);
  // ids de contas já gravadas que o usuário removeu da lista (só são apagadas ao salvar o pedido)
  const [idsRemovidos, setIdsRemovidos] = useState([]);

  const contasNaoSalvas = (formik.values?.contas || []).filter(
    (conta) => !conta._id
  ).length;
  const contasRemovidasNaoSalvas = idsRemovidos.filter(
    (id) => !(formik.values?.contas || []).some((conta) => conta._id === id)
  ).length;

  const columns = [
    {
      Header: "Descrição",
      accessor: "descricao",
      align: "center",
    },
    {
      Header: "Valor",
      accessor: "valor",
      align: "center",
    },
    ...(isDetalhar
      ? []
      : [{ Header: "Situação", accessor: "situacao", align: "center" }]),
    { Header: isDetalhar ? "" : "Ação", accessor: "action", align: "center" },
  ];

  // Depois de editar uma conta já salva: atualiza só as contas a partir do
  // servidor. Mantém contas novas ainda não salvas, as removidas localmente e
  // as alterações locais das outras contas. Antes recarregava o pedido inteiro
  // (refreshParent) e perdia tudo que não tinha sido salvo.
  const recarregarContas = async () => {
    if (!buscarContasSalvas) return refreshParent();
    try {
      const doServidor = (await buscarContasSalvas()) || [];
      const atuais = formik.values.contas || [];
      const locais = new Map(
        atuais.filter((c) => c._id).map((c) => [c._id, c])
      );
      const salvas = doServidor
        .filter((c) => c?._id && !idsRemovidos.includes(c._id))
        .map((c) =>
          c._id !== currentIdAction && locais.has(c._id) ? locais.get(c._id) : c
        );
      const novas = atuais.filter((c) => !c._id);
      formik.setFieldValue("contas", [...salvas, ...novas]);
    } catch (error) {
      console.error(error);
      refreshParent();
    }
  };

  const scrollToTop = () => {
    refAddItem?.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cleanBrl = (valor) => {
    if (typeof valor !== "string") {
      return valor;
    }

    if (valor.includes("R$")) {
      valor = valor.replace("R$", "").trim();
    }
    valor = valor.replace(/\./g, "");
    valor = commaToDot(valor);

    return valor;
  };

  const handleAdd = (conta) => {
    const newRows = rows.map((row) => ({
      ...row,
      valor: cleanBrl(row.valor),
    }));

    const contas = parseContaParcela(conta);

    for (let novaConta of contas) {
      newRows.push({
        ...novaConta,
        valor: Number(commaToDot(novaConta.valor)),
      });
    }

    setShowAddState(false);
    formik.setFieldValue("contas", newRows);
  };

  const handleEditCurrent = (conta) => {
    const newRows = [...rows];
    const idx = newRows.findIndex((row) => row._id === conta._id);
    newRows[idx] = conta;

    setShowEditStateNew(false);
    formik.setFieldValue("contas", newRows);
  };

  const parseContaParcela = (conta) => {
    const podeParcelar = [
      PRAZO_PAGAMENTO.TRINTA_QUARENTA_CINCO,
      PRAZO_PAGAMENTO.TRINTA_SESSENTA,
      PRAZO_PAGAMENTO.TRINTA_QUARENTA_CINCO_SESSENTA,
      PRAZO_PAGAMENTO.TRINTA_SESSENTA_NOVENTA,
    ];

    if (!podeParcelar.includes(conta.prazoPagamento) || !conta.prazoPagamento) {
      conta.valor = commaToDot(conta.valor);
      return [conta];
    }

    if (conta.valor.includes("R$")) {
      conta.valor = conta.valor.replace("R$", "").trim();
    }

    const parcelas = [];
    const valorParcela =
      commaToDot(conta.valor) / PARCELAS_PRAZO_PAGAMENTO[conta.prazoPagamento];
    const diasParcela = DIAS_PRAZO_PAGAMENTO[conta.prazoPagamento];

    for (let i = 0; i < PARCELAS_PRAZO_PAGAMENTO[conta.prazoPagamento]; i++) {
      parcelas.push({
        ...conta,
        descricao: `PARCELA ${i + 1}/${
          PARCELAS_PRAZO_PAGAMENTO[conta.prazoPagamento]
        }`,
        dataVencimento: hojePlusDias(diasParcela[i]),
        valor: valorParcela.toFixed(2),
        idx: Date.now() + i,
      });
    }

    return parcelas;
  };

  // "AAAA-MM-DD" local; antes era Date com a hora atual (à noite virava o dia seguinte)
  const hojePlusDias = (dias) => hojeMaisDias(dias);

  const handleEdit = (conta) => {
    if (conta?._id) {
      setShowEditStateCurr(true);
      setCurrentIdAction(conta._id);
    } else {
      setShowEditStateNew(true);
      setCurrentEditNew(conta);
    }
  };

  const handleDelete = (conta) => {
    if (!formik.values.contas || formik.values.contas.length === 0) return;

    let newRows = [...formik.values.contas];

    if (conta._id) {
      newRows = newRows.filter((row) => row._id !== conta._id);
      setIdsRemovidos((prev) =>
        prev.includes(conta._id) ? prev : [...prev, conta._id]
      );
    }

    if (conta.idx) {
      newRows = newRows.filter((row) => row.idx !== conta.idx);
    }

    formik.setFieldValue("contas", newRows);
  };

  const checkIfHaveRs = (valor) => {
    if (typeof valor !== "string") {
      return valor;
    }

    if (valor.includes("R$")) {
      valor = valor.replace("R$", "").trim();
    }
    valor = commaToDot(valor);

    return valor;
  };

  useEffect(() => {
    setRows(
      formik.values?.contas?.map((conta) => ({
        ...conta,
        action: (
          <div
            style={{
              justifyContent: "center",
              display: isDetalhar ? "none" : "flex",
            }}
          >
            <Tooltip title="Editar">
              <MDButton
                variant="contained"
                color="info"
                type="button"
                sx={{ marginRight: 1 }}
                onClick={() => {
                  handleEdit(conta);
                }}
                iconOnly
              >
                <Icon fontSize="small">edit</Icon>
              </MDButton>
            </Tooltip>

            <Tooltip title="Remover">
              <MDButton
                variant="gradient"
                color="error"
                fullWidth
                type="submit"
                onClick={() => handleDelete(conta)}
                iconOnly
              >
                <Icon fontSize="small">delete_forever</Icon>
              </MDButton>
            </Tooltip>
          </div>
        ),
        situacao: conta._id ? (
          "Salva"
        ) : (
          <span style={{ color: "#d32f2f", fontWeight: 600 }}>Não salva</span>
        ),
        valor: Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(checkIfHaveRs(conta.valor)),
      }))
    );
  }, [formik.values.contas]);

  return (
    <>
      {showAddState && (
        <AdicionarConta
          setShowAddState={setShowAddState}
          handleAdd={handleAdd}
          isReceber={isReceber}
          rows={rows}
          cliente={cliente}
          valorTotal={valorTotal}
          parentDataPedido={formik.values.dataDescarga || null}
          dataPedido={dataPedido}
        />
      )}

      {showEditStateNew && (
        <AdicionarConta
          setShowAddState={setShowEditStateNew}
          handleAdd={handleAdd}
          isReceber={isReceber}
          rows={rows}
          cliente={cliente}
          valorTotal={valorTotal}
          currEdit={currentEditNew}
          handleEditCurrent={handleEditCurrent}
          dataPedido={dataPedido}
        />
      )}

      {showEditStateCurr && isReceber && (
        <EditarDadoReceber
          setShowEditState={setShowEditStateCurr}
          currentIdAction={currentIdAction}
          fetchData={recarregarContas}
          fecharOnSave
          dataPedido={dataPedido}
        />
      )}

      {showEditStateCurr && !isReceber && (
        <EditarDadoPagar
          setShowEditState={setShowEditStateCurr}
          currentIdAction={currentIdAction}
          fetchData={recarregarContas}
          fecharOnSave
          dataPedido={dataPedido}
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {!isDetalhar && (
          <MDButton
            variant="contained"
            color="info"
            type="button"
            onClick={() => {
              scrollToTop();
              setShowAddState(true);
            }}
          >
            Adicionar Item
          </MDButton>
        )}
      </div>

      {!isDetalhar && (contasNaoSalvas > 0 || contasRemovidasNaoSalvas > 0) && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <b>Alterações ainda não gravadas: </b>
          {[
            contasNaoSalvas > 0 && `${contasNaoSalvas} conta(s) nova(s)`,
            contasRemovidasNaoSalvas > 0 &&
              `${contasRemovidasNaoSalvas} conta(s) removida(s)`,
          ]
            .filter(Boolean)
            .join(" e ")}
          . Elas só serão gravadas quando você clicar em <b>Salvar</b> no
          pedido.
        </Alert>
      )}

      {rows?.length > 0 && (
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={{
            defaultValue: 25,
          }}
          noEndBorder
        />
      )}

      {rows?.length === 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: 5,
          }}
        >
          Nenhuma conta adicionada
        </div>
      )}
    </>
  );
}
